import { ArrowUpDown, ArrowUp, ArrowDown } from "lucide-react";

interface CompaniesTableHeaderProps {
  sortColumn?: string;
  sortDirection?: "asc" | "desc";
  onSort: (column: string) => void;
}

export function CompaniesTableHeader({
  sortColumn,
  sortDirection,
  onSort,
}: CompaniesTableHeaderProps) {
  const getSortIcon = (column: string) => {
    if (sortColumn !== column) {
      return <ArrowUpDown className="h-3 w-3 ml-1 opacity-50" />;
    }
    return sortDirection === "desc" ? (
      <ArrowDown className="h-3 w-3 ml-1" />
    ) : (
      <ArrowUp className="h-3 w-3 ml-1" />
    );
  };

  return (
    <thead>
      <tr className="border-b border-grid-200 bg-grid-50">
        <th className="px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider text-ink-600">
          <div
            className="flex items-center cursor-pointer hover:opacity-80 select-none"
            onClick={() => onSort("name")}
          >
            Name
            {getSortIcon("name")}
          </div>
        </th>
        <th className="px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider text-ink-600">
          <div
            className="flex items-center cursor-pointer hover:opacity-80 select-none"
            onClick={() => onSort("linkedInUrl")}
          >
            LinkedIn URL
            {getSortIcon("linkedInUrl")}
          </div>
        </th>
        <th className="px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider text-ink-600">
          <div
            className="flex items-center cursor-pointer hover:opacity-80 select-none"
            onClick={() => onSort("createdDate")}
          >
            Created
            {getSortIcon("createdDate")}
          </div>
        </th>
        <th className="px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider text-ink-600">
          <div
            className="flex items-center cursor-pointer hover:opacity-80 select-none"
            onClick={() => onSort("isActive")}
          >
            Status
            {getSortIcon("isActive")}
          </div>
        </th>
        <th className="px-6 py-4 text-right text-xs font-semibold uppercase tracking-wider text-ink-600">
          Actions
        </th>
      </tr>
    </thead>
  );
}
